var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.options, function(opt) {
      return _c("div", { key: opt.value, staticClass: "checkbox" }, [
        _c("label", [
          _c("input", {
            attrs: { type: "checkbox" },
            domProps: { checked: _vm.isChecked(opt.value) },
            on: {
              change: function($event) {
                return _vm.checkOption(opt.value)
              }
            }
          }),
          _vm._v("\n      " + _vm._s(opt.text) + "\n    ")
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }